import React from 'react';
import { useTour } from '@reactour/tour';
import { createUseStyles } from 'react-jss';
import SusyDarkMode from './assets/img/wanna/susy/susy-dark-mode.png';
import Susy2 from './assets/img/wanna/susy/susy2.png';
import Button from './components/bootstrap/Button';

/**
 * Steps style
 */
export const styles = {
	/**
	 * Overlay style
	 * @param base
	 */
	maskWrapper: (base: any) => ({ ...base }),
	maskArea: (base: any) => ({
		...base,
		rx: 'var(--bs-border-radius)',
	}),
	highlightedArea: (base: any) => ({ ...base }),
	badge: (base: any) => ({ ...base }),
	popover: (base: any) => ({
		...base,
		boxShadow: '0 0 3em rgba(0, 0, 0, 0.5)',
		backgroundColor: 'var(--bs-body-bg)',
		color: 'var(--bs-body-color)',
		borderRadius: 'var(--bs-border-radius)',
	}),
};

/**
 * Image Styles
 * @type {(data?: {theme?: DefaultTheme}) => Classes<"image">}
 */
const useStyles = createUseStyles({
	image: {
		maxHeight: '150px',
		objectFit: 'contain',
	},
});

/**
 * Prev & Next buttons
 * @returns {JSX.Element}
 * @constructor
 */
const TourNavigation = () => {
	const { currentStep, setCurrentStep } = useTour();
	return (
		<div className='col-12 mt-3'>
			<div className='row'>
				<div className='col'>
					{!!currentStep && (
						<Button
							icon='ArrowBackIos'
							color='info'
							isLink
							onClick={() => setCurrentStep(currentStep - 1)}>
							Prev
						</Button>
					)}
				</div>
				<div className='col-auto'>
					<Button
						icon='ArrowForwardIos'
						color='info'
						isLight
						onClick={() => setCurrentStep(currentStep + 1)}>
						Next
					</Button>
				</div>
			</div>
		</div>
	);
};

/**
 * Selector
 * @param name
 * @returns {`[data-tour='${string}']`}
 */
const getTargetName = (name: string): `[data-tour='${string}']` => {
	return `[data-tour='${name}']`;
};

const DarkModeTour = () => {
	const classes = useStyles();
	return (
		<div className='row'>
			<div className='col-md-5'>
				<img src={SusyDarkMode} className={classes.image} width='100%' alt='' />
			</div>
			<div className='col-md-7 d-flex align-items-center'>
				<div>
					<p className='lead'>Dark / Light Mode</p>
					<p>You can switch between dark and light mode.</p>
				</div>
			</div>
			<TourNavigation />
		</div>
	);
};

const ProfileMenuTour = () => {
	const classes = useStyles();
	return (
		<div className='row'>
			<div className='col-md-4'>
				<img src={Susy2} className={classes.image} width='100%' alt='' />
			</div>
			<div className='col-md-8 d-flex align-items-center'>
				<div>
					<p className='lead'>Profile Menu</p>
					<p>Click here to either go to your "Profile" or "Log out" of your dashboard</p>
				</div>
			</div>
			<TourNavigation />
		</div>
	);
};

const FullScreenTour = () => {
	const classes = useStyles();
	return (
		<div className='row'>
			<div className='col-md-4'>
				<img src={Susy2} className={classes.image} width='100%' alt='' />
			</div>
			<div className='col-md-8 d-flex align-items-center'>
				<div>
					<p className='lead'>Fullscreen Mode</p>
					<p>
						Enable full screen mode to block out distractions while working on your
						dashboard
					</p>
				</div>
			</div>
			<TourNavigation />
		</div>
	);
};

const DocumentationTour = () => {
	const classes = useStyles();
	return (
		<div className='row'>
			<div className='col-md-4'>
				<img src={Susy2} className={classes.image} width='100%' alt='' />
			</div>
			<div className='col-md-8 d-flex align-items-center'>
				<div>
					<p className='lead'>Documentation</p>
					<p>Read our API and Integration documentation.</p>
				</div>
			</div>
			<TourNavigation />
		</div>
	);
};

const CreateProjectTour = () => {
	const classes = useStyles();
	return (
		<div className='row'>
			<div className='col-md-4'>
				<img src={Susy2} className={classes.image} width='100%' alt='' />
			</div>
			<div className='col-md-8 d-flex align-items-center'>
				<div>
					<p className='lead'>Create Project</p>
					<p>Quickly and easily create new project within the current organization</p>
				</div>
			</div>
			<TourNavigation />
		</div>
	);
};

const SwitchOrganizationTour = () => {
	const classes = useStyles();
	return (
		<div className='row'>
			<div className='col-md-4'>
				<img src={Susy2} className={classes.image} width='100%' alt='' />
			</div>
			<div className='col-md-8 d-flex align-items-center'>
				<div>
					<p className='lead'>Switch Organization</p>
					<p>Switch between any and all organization you are a team of.</p>
				</div>
			</div>
			<TourNavigation />
		</div>
	);
};

const NotificationTour = () => {
	const classes = useStyles();
	return (
		<div className='row'>
			<div className='col-md-4'>
				<img src={Susy2} className={classes.image} width='100%' alt='' />
			</div>
			<div className='col-md-8 d-flex align-items-center'>
				<div>
					<p className='lead'>Notifications</p>
					<p>
						Access all your notifications. Action to take and how to take them are all
						shown here
					</p>
				</div>
			</div>
			<TourNavigation />
		</div>
	);
};

const SwicthProjectStatetour = () => {
	const classes = useStyles();
	return (
		<div className='row'>
			<div className='col-md-4'>
				<img src={Susy2} className={classes.image} width='100%' alt='' />
			</div>
			<div className='col-md-8 d-flex align-items-center'>
				<div>
					<p className='lead'>Switch Project State</p>
					<p>Switch between live and sandbox environment on a project here</p>
				</div>
			</div>
			<TourNavigation />
		</div>
	);
};

const CurrenProjectStatusTour = () => {
	const classes = useStyles();
	return (
		<div className='row'>
			<div className='col-md-4'>
				<img src={Susy2} className={classes.image} width='100%' alt='' />
			</div>
			<div className='col-md-8 d-flex align-items-center'>
				<div>
					<p className='lead'>Project Status</p>
					<p>The environment of your project is displayed here</p>
				</div>
			</div>
			<TourNavigation />
		</div>
	);
};

const SelectedCompanyTour = () => {
	const classes = useStyles();
	return (
		<div className='row'>
			<div className='col-md-4'>
				<img src={Susy2} className={classes.image} width='100%' alt='' />
			</div>
			<div className='col-md-8 d-flex align-items-center'>
				<div>
					<p className='lead'>Active Organization</p>
					<p>This is the currently active organization.</p>
				</div>
			</div>
			<TourNavigation />
		</div>
	);
};

/**
 * Tour Steps
 */
const steps = [
	/**
	 * Dark Mode
	 * @step 0
	 */
	{
		selector: getTargetName('dark-mode'),
		content: () => <DarkModeTour />,
	},
	/**
	 * Profile tour
	 * @step 1
	 */
	{
		selector: getTargetName('profile-tour'),
		content: () => <ProfileMenuTour />,
	},
	/**
	 * Full screen
	 * @step 2
	 */
	{
		selector: getTargetName('full-screen'),
		content: () => <FullScreenTour />,
	},
	/**
	 * Documentation
	 * @step 3
	 */
	{
		selector: getTargetName('documentation-tour'),
		content: () => <DocumentationTour />,
	},
	/**
	 * Create Project
	 * @step 4
	 */
	{
		selector: getTargetName('create-project-tour'),
		content: () => <CreateProjectTour />,
	},
	/**
	 * Change Organization
	 * @step 5
	 */
	{
		selector: getTargetName('switch-organization-tour'),
		content: () => <SwitchOrganizationTour />,
	},
	/**
	 * View Notification
	 * @step 6
	 */
	{
		selector: getTargetName('notification-tour'),
		content: () => <NotificationTour />,
	},
	/**
	 * Switch Project
	 * @step 7
	 */
	{
		selector: getTargetName('switch-project-tour'),
		content: () => <SwicthProjectStatetour />,
	},
	/**w
	 * Project Status
	 * @step 8
	 */
	{
		selector: getTargetName('project-state-tour'),
		content: () => <CurrenProjectStatusTour />,
	},
	/**
	 * Active Organization
	 * @step 9
	 */
	{
		selector: getTargetName('active-organization-tour'),
		content: () => <SelectedCompanyTour />,
	},
	/**
	 * Profile tour
	 * @step 10
	 */
	{
		selector: getTargetName('profile-bottom-tour'),
		content: () => <ProfileMenuTour />,
	},
];

export default steps;
